import { render, staticRenderFns } from "./boxItem.vue?vue&type=template&id=229a92ee&"
import script from "./boxItem.vue?vue&type=script&lang=js&"
export * from "./boxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports